import CallToActionComponent, {
  CallToActionProps,
} from "@/components/CallToAction";
import ImageWithHotspotsComponent, {
  ImageWithHotspotsProps,
} from "./ImageWithHotspots";

// Cast to fix React 17 + @types/react 18 compatibility issue
const CallToAction = CallToActionComponent as any;
const ImageWithHotspots = ImageWithHotspotsComponent as any;
import {
  Body,
  ButtonsContainer,
  CardsContainer,
  Container,
  Heading,
  TextContainer,
  TextInner,
} from "./styles";

export type TextWithCardsProps = {
  heading: string | null;
  body: string | null;
  images: ImageWithHotspotsProps[] | null;
  buttons: ({ _key: string } & CallToActionProps)[] | null;
};

const TextWithCards: React.FC<TextWithCardsProps> = (props) => {
  const { heading, body, images, buttons } = props;
  return (
    <Container>
      <TextContainer>
        <TextInner>
          {heading && <Heading>{heading}</Heading>}
          {body && <Body>{body}</Body>}
          <ButtonsContainer>
            {buttons?.map((button) => (
              <CallToAction key={button._key} {...button} />
            ))}
          </ButtonsContainer>
        </TextInner>
      </TextContainer>
      <CardsContainer>
        {images?.map((image) => (
          // eslint-disable-next-line jsx-a11y/alt-text
          <ImageWithHotspots key={image._key} {...image} />
        ))}
      </CardsContainer>
    </Container>
  );
};

export default TextWithCards;
